/**
 * Pricing display helpers for subservices
 */
import { formatCurrency as formatCurrencyLocalized } from './format';

export function formatCurrency(amount: string | null | undefined): string {
  if (!amount) {
    return '—';
  }
  return formatCurrencyLocalized(amount);
}

export function formatSubservicePrice(item: {
  uses_dual_pricing: boolean;
  price?: string | null;
  specialist_price?: string | null;
  consultant_price?: string | null;
}): string {
  if (item.uses_dual_pricing) {
    const specialist = formatCurrency(item.specialist_price);
    const consultant = formatCurrency(item.consultant_price);
    return `${specialist} / ${consultant}`;
  }
  return formatCurrency(item.price);
}
